<template>
    <div
        class="rounded-xl h-full w-full space-y-4 flex flex-col"
        :class="{
            'bg-white border border-stone-200 shadow-xs':
                !noColors && !isActive,
            'bg-primary-shade-ligth border border-transparent ring-2 ring-inset ring-primary shadow-xs':
                !noColors && isActive,
            'hover:ring-2 hover:ring-inset hover:ring-primary':
                shouldHighlightOnHover,
            'ring-2 ring-inset ring-primary': isHighlighted,
            'p-0': paddingSize === 'none',
            'p-2': paddingSize === 'small',
            'p-4': paddingSize === 'medium',
            'p-6': paddingSize === 'large',
        }"
    >
        <div v-if="slots.title">
            <slot name="title" />
        </div>
        <CardTitle
            v-if="title"
            :title="title"
            :iconName="iconName"
            :iconClass="iconClass"
        />
        <div class="flex-1 items-stretch">
            <slot name="content" />
        </div>
        <div
            v-if="slots.actions"
            class="flex justify-end"
        >
            <slot name="actions" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useSlots, type PropType } from 'vue'
    import CardTitle from '@/Shared/Component/CardTitle.vue'

    const props = defineProps({
        noColors: {
            type: Boolean,
            default: false,
        },
        paddingSize: {
            type: String as PropType<'none' | 'small' | 'medium' | 'large'>,
            default: 'large',
        },
        title: {
            type: String,
            default: null,
        },
        iconName: {
            type: String,
            default: null,
        },
        iconClass: {
            type: String,
            default: 'w-4 h-4 text-gray-600',
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        shouldHighlightOnHover: {
            type: Boolean,
            default: false,
        },
        isHighlighted: {
            type: Boolean,
            default: false,
        },
    })

    const slots: any = useSlots()
</script>
